<template>
  <div class="card">
    <h3>
      Active Passengers: {{ intervalNotation }}
    </h3>
    <p>
      What is the number of your active passengers for the {{ intervalNotation }}?
    </p>
    <div class="bar-chart-holder">
      <BarChart
          class="bar-chart"
          label="Active passengers"
          :item-data="itemData"
          :width="600"
          :height="300"
      />
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import BarChart from './BarChart.vue';

export default {
  name: 'BarChartPassengers',
  components: {
    BarChart,
  },

  props: {
    itemData: {
      type: Array,
      default() {
        return ([]);
      },
    },
  },

  computed: {
    ...mapGetters({
      intervalNotation: 'controls/intervalNotation',
    }),
  },
};
</script>
<style scoped>
/*bar chart*/
.bar-chart-holder {
  padding: 0;
}

.bar-chart {
  margin: 0 auto;
}

.bar-chart-legend .legend-color {
  width: 2em;
  border-radius: 0;
}

.overview-sum {
  padding-right: 30px;
}

h4 {
  padding-bottom: 10px;
  font-size: 18px;
  font-weight: 500;
}

.card h3 {
  font-size: 20px;
  margin-bottom: 8px;
}

.card p {
  font-size: 18px;
  color: #bfbfbf;
  margin-bottom: 8px;
}
</style>
